import { render, staticRenderFns } from "./OSD.vue?vue&type=template&id=48775830&scoped=true&"
import script from "./OSD.vue?vue&type=script&lang=js&"
export * from "./OSD.vue?vue&type=script&lang=js&"
import style0 from "./OSD.vue?vue&type=style&index=0&id=48775830&scoped=true&lang=css&"
import style1 from "./OSD.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48775830",
  null
  
)

export default component.exports